import goFreshLogo from 'assets/images/backoffice/fresh/gofresh-logo.png';
import googlePlay from 'assets/images/backoffice/fresh/google-play-logo.png';
import React from 'react';
import './PhaseOut.css';

const GoFreshDesktop = () => {
  return (
    <div>
      <div className="action-group gofresh">
        <p className="label-action-gofresh">Hanya tersedia di mobile</p>
        <a
          target="_blank"
          href="https://play.google.com/store/apps/details?id=com.gojek.resto"
        >
          <img src={googlePlay} className="google-play" />
        </a>
      </div>
    </div>
  );
};

const RegisterGoFresh = () => {
  return (
    <div>
      <p className="label-gofresh">
        GoFresh saat ini belum tersedia di kota anda
      </p>
      <div className="action-group gofresh">
        <img src={goFreshLogo} className="brand-logo" />
        <a
          target="_blank"
          href="https://forms.gle/6mDL5Hx1DUKrpAby8"
          className="shop-fresh gofresh"
        >
          Daftar
        </a>
      </div>
    </div>
  );
};

const ShopGoFresh = () => {
  return (
    <div className="action-group gofresh">
      <img src={goFreshLogo} className="brand-logo" />
      <a
        target="_blank"
        href="https://gobiz.onelink.me/oR68/afe7a449"
        className="shop-fresh gofresh"
      >
        Mulai Belanja
      </a>
    </div>
  );
};

const GoFreshMobile = ({ isEligible }) => {
  return isEligible ? <ShopGoFresh /> : <RegisterGoFresh />;
};

const GoFresh = ({ mobile, isEligible }) => {
  return mobile ? (
    <GoFreshMobile isEligible={isEligible} />
  ) : (
    <GoFreshDesktop />
  );
};

export default GoFresh;
